// 计提等一些通用操作 todo（根据情况，可以对外暴露多个func,而不是提供class）
import { getGridSelectedIds, getGridSelected } from '@/utils/agGrid'
import { Assert } from '@/utils/validate'
import {
  jobAccountVerify,
  jobVerifyByRange,
  updateProvisioned,
  jobSingleAccountVerify
} from '@/api/clearing/financeManage'
import lodash from 'lodash'
import { cacheName, cache } from '@/utils/cacheManager'

import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { ClearingUtils } from '@/class/cargo/model/utils/ClearingUtils'
import * as LoadDefaultQueryParam from '@/utils/LoadDefaultQueryParam'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import { Job } from '@/class/model/booking/Job'
import AbstractViewManage from '@/class/view/AbstractViewManage'
import LocalStorageUtils from '@/utils/localStorageUtils'
import { queryChargeByField, sendHecMessageByFinance } from '@/api/clearing/charge'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import * as ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import { OPERATE_AUDIT } from '@/class/cargo/model/parameters/SystemConstants'
import ArchiveEffectUtils from '@/class/cargo/model/utils/ArchiveEffectUtils'
import { getEffectConfig } from '@/api/sysManage/baseConfig/financialArchivingSetting'

export default class AbstractFinanceManage extends AbstractViewManage {
  /**
   * 是否审核连小票一起审核
   */
  _allSubmitFcl=false
  /**
   * 费用审核
   */
  _isChargeSubmitDirect=false

  _openSapConfig=false

  _openHecConfig=false

  _useCheckRule=false

  _financeBtnGroupView=null
  constructor(view) {
    super(view)
    this._job = null
    // todo-shengsheng  Desc: 测试 此属性 是否双向
    this.totalGroup = { dataProvider: [] } // 利润
    this.totalGroupIncome = { dataProvider: [] } // 应收
    this.totalGroupCost = { dataProvider: [] } // 应付
    this.chargeCountGroup = { dataProvider: [], selectedCount: 0, showCurrency: false } // 详情合计
    this.totalProfits = [] //
    this.showSelectionCount = false // 显示 选中的数量
    this.showChargeCount = true
    this.allChargeSummary = [] // 合计费用摘要
    this.needCalcAfterLoadTotalProfit = false // 需要在 利润加载完后，刷新合计利润数据
    this.selectionUuids = null

    this.isCommittedAllowAddCost = false
  }

  get financeBtnGroupView() {
    return this._financeBtnGroupView
  }

  set financeBtnGroupView(value) {
    this._financeBtnGroupView = value
  }

  get job() {
    return this._job
  }

  set job(value) {
    this._job = value
  }

  get view() {
    return this._view
  }

  set view(value) {
    this._view = value
  }

  beforeMount() {
    cache.load(cacheName.CONFIG).then(() => {
      this.allSubmitFcl = Boolean(cache.config.get('AllSubmitFcl'))
      this.isChargeSubmitDirect = Number(cache.config.get('ChargeSubmitDirect')) === 1
      this.isCommittedAllowAddCost = parseInt(cache.config.get('IsCommittedAllowAddCost')) === 1
      this.openSapConfig = parseInt(cache.config.get('openSapConfig')) === 1
      this.openHecConfig = parseInt(cache.config.get('openHecConfig')) === 1
      this.useCheckRule = parseInt(cache.config.get('useCheckRule')) === 1
    })
  }

  /**
   * 创建完的回调钩子，尽量不要放置异步代码-避免使用不当出现问题
   */
  created() {

  }
  get openSapConfig() {
    return this._openSapConfig
  }

  set openSapConfig(value) {
    this._openSapConfig = value
  }

  get openHecConfig() {
    return this._openHecConfig
  }

  set openHecConfig(value) {
    this._openHecConfig = value
  }

  get useCheckRule() {
    return this._useCheckRule
  }

  set useCheckRule(value) {
    this._useCheckRule = value
  }

  get isChargeSubmitDirect() {
    return this._isChargeSubmitDirect
  }

  set isChargeSubmitDirect(value) {
    this._isChargeSubmitDirect = value
  }

  get isCommittedAllowAddCost() {
    return this._isCommittedAllowAddCost
  }

  set isCommittedAllowAddCost(value) {
    this._isCommittedAllowAddCost = value
  }

  get allSubmitFcl() {
    return this._allSubmitFcl
  }

  set allSubmitFcl(value) {
    this._allSubmitFcl = value
  }

  async initCache() {
    await cache.load(cacheName.CONFIG)
    this.allSubmitFcl = Boolean(cache.config.get('AllSubmitFcl'))
    this.isChargeSubmitDirect = Number(cache.config.get('ChargeSubmitDirect')) === 1
    this.isCommittedAllowAddCost = parseInt(cache.config.get('IsCommittedAllowAddCost')) === 1
    this.openSapConfig = parseInt(cache.config.get('openSapConfig')) === 1
    this.openHecConfig = parseInt(cache.config.get('openHecConfig')) === 1
    this.useCheckRule = parseInt(cache.config.get('useCheckRule')) === 1
  }

  // 核对审核日期
  async checkAccountDate(accountDate) {
    // 交给子类实现
  }

  /**
   * 改单审核提交回调
   * @param accountingDate
   * @returns {Promise<void>}
   */
  async batchCheckChangeConfirmCB(jobKeys, accountingDate, location) {
    await this.checkAccountDate(accountingDate)

    await Job.updateChangeState(jobKeys, { changeState: SystemConstants.CHANGE_AUDIT.code, branchId: this.$store.getters.currentOfficeId, accountingDate, location: location }).then(res => {
      // CARGO-697，取消审核：不可改单、改单审核
      this.$message.success(this.view.$t('Clearing.ChangeOrderApprovalSuccess'))
      this.financeBtnGroupView.refresh()
    }).catch(err => {
      // todo
    }).finally(() => {
      this.financeBtnGroupView.showChangeDialog = false
    })
  }
  async batchAuditConfirmCB(jobKeys, accountDate, poNo, single = false, location) {
    this.financeBtnGroupView.adjustPageDate = new Date(accountDate)
    await this.checkAccountDate(accountDate)
    let operateNameCode = SystemConstants.OPERATE_BATCH_AUDIT.code
    const branchId = this.$store.getters.currentOfficeId
    this.loading()
    let func = jobAccountVerify
    if (single) {
      func = jobSingleAccountVerify
      // CARGO-32212 财务审核，点击业务内的 单票 的审核按钮，业务日志里显示是批量审核
      operateNameCode = SystemConstants.OPERATE_AUDIT.code
    }
    await func({ operateNameCode, jobKeys, accountingDate: accountDate, allSubmitFcl: this.allSubmitFcl, poNo, branchId, location }).then(res => {
      if (this.openHecConfig) {
        this.commitSapResultHandler(jobKeys, res.data)
      } else {
        this.updateDefaultMenuState('manage')
        this.batchAuditConfirmSuccessCB(res.data)
      }
    }).catch(err => {
      this.batchAuditConfirmFailCB()
    }).finally(() => {
      this.closeLoading()
      this.financeBtnGroupView.showCheckDialog = false
    })
  }

  async commitSapResultHandler(jobKeys, data) {
    await sendHecMessageByFinance(jobKeys, ChargeUtils.CHARGE_SH.code).then(res => {
      this.sendSapMessageSuccess(res, data)
    }).catch((err) => {
      this.failureHandler(err)
    })
  }

  sendSapMessageSuccess(res, data) {
    let r = 'failure'
    if (res && Number(res.data) > 0) {
      r = 'success'
      this.$message.success(this.$t('Message.SapSynchronizationSuccess'))
    } else {
      this.$message.error(this.$t('Message.SapSynchronizationFault'))
    }
    this.updateDefaultMenuState('manage')
    this.batchAuditConfirmSuccessCB(data)
    this.$logger.log('chargeInfo sendSapSuccess key: ' + this._view.job.uuid + ' result:  ' + r)
  }

  async cancelAdjustDate(pageDate) {
    this.financeBtnGroupView.adjustPageDate = new Date(pageDate)
  }
  async batchAuditConfirmSuccessCB(res) {

  }

  async batchAuditConfirmFailCB() {

  }
  updateResultProvisioned(state) {
    // 列表刷新
    const jobList = getGridSelected(this._view.gridOptions)
    for (const job of jobList) {
      if (state === 1) {
        if (!job.provisioned) {
          job.provisioned = true
        }
      } else {
        if (job.provisioned) {
          job.provisioned = false
        }
      }
      this._view.gridOptions.api.refreshCells({ force: true })
    }
  }

  refresh() {
    // 交给子类实现
  }
  // 取消计提
  async cancelProvisionedClickHandler() {
    const list = getGridSelected(this._view.gridOptions)
    // 查询归档生效配置
    let effectConfig = {}
    await getEffectConfig(this.$store.getters.currentOfficeId).then(res => {
      if (res.data) {
        effectConfig = res.data
      }
    })
    if (effectConfig && effectConfig.modifyAccrual === 1) {
      for (const item of list) {
        // 财务归档生效判断
        const warnflag = ArchiveEffectUtils.checkArchiveEffect(item)
        if (warnflag) {
          this.$message.warning(this._view.$t('CargoMsg.NOT_OPERATIONAL'))
          return
        }
      }
    }
    await this.updateProvisionedStateClickHandler(list, 0)
    // this.financeBtnGroupView.showCancelProvisionedDialog = true
    this.cancelProvisionedConfirmCB(null)
  }
  // 计提
  async provisionedClickHandler() {
    const list = getGridSelected(this._view.gridOptions)
    await this.updateProvisionedStateClickHandler(list, 1)
    this.financeBtnGroupView.showProvisionedDialog = true
  }
  /**
   * 更新计提状态
   * @param state 0 取消，1计提
   * @returns {Promise<void>}
   */
  async updateProvisionedStateClickHandler(jobs, state) {
    await Assert.isTrue(jobs.length > 0, `${this.view.$t('Clearing.PleaseSelect')}${state === 1 ? '' : this.$t('Clearing.Cancel')}${this.view.$t('Clearing.ProvisionalBusinesses')}`, 'warning')
    for (const job of jobs) {
      // console.log('job.provisioned', job.provisioned, state, (!job.provisioned) && state === 1)
      if (state === 1) {
        await Assert.isTrue(!job.provisioned && state === 1, job.jobNo + this.$t('Clearing.ForPleaseChooseUnprovisionedBusiness'), 'warning')
      } else {
        await Assert.isTrue(job.provisioned && state === 0, job.jobNo + this.$t('Clearing.ForPleaseChooseProvisionedBusiness'), 'warning')
      }
    }
  }

  async updateProvisionedConfirmCB(jobKeys, provisionedDate, state) {
    await updateProvisioned(jobKeys, { provisionedDate, value: state }).then(res => {
      if (state === 1) {
        this.$message.success(this.$t('Clearing.ProvisionSuccess'))
      } else {
        this.$message.success(this.$t('Clearing.CancellationProvisionsSuccess'))
      }
      this.updateResultProvisioned(state)
    }).catch(err => {
      this.failureHandler(err)
    })
  }

  /**
   * 计提弹框确认回调
   * @param provisionedDate
   * @returns {Promise<void>}
   */
  async provisionedConfirmCB(provisionedDate) {
    const jobKeys = await getGridSelectedIds(this._view.gridOptions, 'uuid')
    await this.updateProvisionedConfirmCB(jobKeys, provisionedDate, 1)
    this.financeBtnGroupView.showProvisionedDialog = false
  }

  /**
   * 取消计提确认
   * @param provisionedDate
   * @returns {Promise<void>}
   */
  async cancelProvisionedConfirmCB(provisionedDate) {
    const jobKeys = await getGridSelectedIds(this._view.gridOptions, 'uuid')
    await this.updateProvisionedConfirmCB(jobKeys, provisionedDate, 0)
    this.financeBtnGroupView.showCancelProvisionedDialog = false
  }

  async lockJobsClickHandler() {
    const selectedRows = getGridSelected(this._view.gridOptions) || []
    const auditedJob = selectedRows.find(job => Number(job.jobState) === Number(SystemConstants.STATE_VERIFIED.code))
    if (auditedJob) {
      this.$message.warning(this.$t('Message.OrderAlreadyApproved', [auditedJob.jobNo]))
      return
    }
    // 锁单
    if (this.financeBtnGroupView && this.financeBtnGroupView.getLockOrderDefaultJobNos) {
      this.financeBtnGroupView.lockOrderDefaultJobNos = this.financeBtnGroupView.getLockOrderDefaultJobNos()
    }
    this.financeBtnGroupView.showLockOrderDialog = true
  }

  lockOrderConfirmCB(formData) {
    const loading = getLoading4Cxt(formData.componet ? formData.componet : this.view)
    if (formData.componet) delete formData.componet
    formData.branchId = this.$store.getters.currentOfficeId
    jobVerifyByRange(formData).then(res => {
      if (res.data === 'ok') {
        this.$message.success(this._view.$t('FinanceManage.lockBusinessSuccess'))
      } else if (res.data === 'repeatClick') {
        this.$message.warning(this._view.$t('Message.RepeatClick'))
        return
      } else {
        this.$message.success(this._view.$t('Message.AsynchronousLocking'))
      }
      this.financeBtnGroupView.showLockOrderDialog = false
      this.refresh()
    }).finally(() => {
      loading.close()
    })
  }

  failureHandler(err) {
    this.$message(this.$t('Clearing.FrontEndErrorCallbackFailed') + err)
  }

  initializeHandler() {
    const defaultSearchFields = [] // 默认高级查询项 todo
    // const jobFields = []
    cache.load(cacheName.CONFIG)
    // 直接加载json文件里面了
    // const jobStateParam = '' // 原代码 就没赋值
    // const states = await LoadDefaultQueryParam.getConfigQueryParam(jobStateParam, SystemConstants.JOB_STATES)
    // if (states && states.length > 0) {
    // const searchField = new AdvancedSearchField()
    // searchField.itemType = 'select'
    // searchField.defaultSelected = 1
    // searchField.selected = 1
    // searchField.multiple = 1
    // searchField.itemValue = []
    // searchField.itemLabel = 'Billing.billingCharge_businessStatus'
    // searchField.itemName = 'job.job_state'
    //
    // searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
    // // searchField.dropdownDataRef = ''
    // searchField.dataProvider = states
    //
    // // 高级查询额外字段渲染
    // jobFields.push(searchField.formatObj2Json())
    //
    // this._view.customSearchItems = [...jobFields]
    // }
    // todo
    // defaultSearchFields.addItemAt(jobFields.getItemAt(14),4);

    this._view.userJobByRole = this.$checkPermission(['role_ACPayAuth_userJob'])
  }

  getUserDepartmentTeamHandler(results, queryMasterDb = false) {
    if (results) {
      this._view.departmentTeamUser = results
    }
    // 查询同组人业务
    if (this._view.departmentTeamUser && this._view.departmentTeamUser.length > 0) {
      this.queryDataRole(true, queryMasterDb)
    }
  }
  /**
   * 同组或个人查询
   */
  queryDataRole(isDepartment = true, queryMasterDb = false) {
    const roleMap = this.getRoleByOpUsers(isDepartment)
    const roleOp = roleMap['roleOp']
    const roleSales = roleMap['roleSales']
    const roleCsr = roleMap['roleCsr']
    const roleDc = roleMap['roleDc']
    // AdvancedSearchOption.removeOption('job.op_id', this._view.searchConditions.snapshotConditions)
    if (AdvancedSearchOption.hasField('job.op_id', this._view.searchConditions.snapshotConditions)) {
      AdvancedSearchOption.removeOption('job.op_id', this._view.searchConditions.snapshotConditions)
    }
    if (AdvancedSearchOption.hasField('job.sales_id', this._view.searchConditions.snapshotConditions)) {
      AdvancedSearchOption.removeOption('job.sales_id', this._view.searchConditions.snapshotConditions)
    }
    if (AdvancedSearchOption.hasField('job.csr_id', this._view.searchConditions.snapshotConditions)) {
      AdvancedSearchOption.removeOption('job.csr_id', this._view.searchConditions.snapshotConditions)
    }
    if (AdvancedSearchOption.hasField('job.dc_id', this._view.searchConditions.snapshotConditions)) {
      AdvancedSearchOption.removeOption('job.dc_id', this._view.searchConditions.snapshotConditions)
    }
    const controlled = this.$checkPermission(['button_Charge_controlled'])
    const costControlled = this.$checkPermission(['button_Charge_costControlled'])
    this.toQueryListWithProfitAndList({ 'roleOp': roleOp, 'roleSales': roleSales, 'roleCsr': roleCsr, 'roleDc': roleDc, 'controlled': controlled, 'costControlled': costControlled }, queryMasterDb)
  }
  /**
   * 查询操作
   */
  getRoleByOpUsersOld(isDepartment) {
    const role = {}
    const roleOp = []
    const roleSales = []
    const currentUserId = this._view.$store.getters.userId
    const $conditions = this._view.searchConditions.snapshotConditions
    if (AdvancedSearchOption.hasField('job.op_id', $conditions) && AdvancedSearchOption.hasField('job.sales_id', $conditions)) {
      const searchOp = AdvancedSearchOption.getOption('job.op_id', $conditions)
      const searchOpEqualOperation = searchOp.operator === '=' // 【等于】条件
      const searchSales = AdvancedSearchOption.getOption('job.sales_id', $conditions)
      const searchSalesEqualOperation = searchSales.operator === '=' // 【等于】条件
      if (!isDepartment) {
        if (searchOpEqualOperation ? Number(searchOp.value) === currentUserId : Number(searchOp.value) !== currentUserId) {
          roleOp.push(currentUserId)
        } else {
          roleOp.push(-1)
        }
        if (searchSalesEqualOperation ? Number(searchSales.value) === currentUserId : Number(searchSales.value) !== currentUserId) {
          roleSales.push(currentUserId)
        } else {
          roleSales.push(-1)
        }
      } else {
        if (this._view.departmentTeamUser && this._view.departmentTeamUser.length > 0) {
          if (searchOpEqualOperation) {
            if (this._view.departmentTeamUser.includes(searchOp.value)) {
              roleOp.push(searchOp.value)
            } else {
              if (Number(searchOp.value) === currentUserId) {
                roleOp.push(currentUserId)
              } else {
                roleOp.push(-1)
              }
            }
            if (this._view.departmentTeamUser.includes(searchSales.value)) {
              roleSales.push(searchSales.value)
            } else {
              if (Number(searchSales.value) === currentUserId) {
                roleSales.push(currentUserId)
              } else {
                roleSales.push(-1)
              }
            }
          } else {
            roleOp.push(...([...this._view.departmentTeamUser, currentUserId]).filter(item => {
              return item !== searchOp.value
            }))
            roleSales.push(...([...this._view.departmentTeamUser, currentUserId]).filter(item => {
              return item !== searchSales.value
            }))
          }
        }
      }
    } else if (AdvancedSearchOption.hasField('job.op_id', $conditions) && !AdvancedSearchOption.hasField('job.sales_id', $conditions)) {
      const searchOp1 = AdvancedSearchOption.getOption('job.op_id', $conditions)
      const searchOpEqualOperation = searchOp1.operator === '=' // 【等于】条件
      if (!isDepartment) {
        if (searchOpEqualOperation ? Number(searchOp1.value) === currentUserId : Number(searchOp1.value) !== currentUserId) {
          roleOp.push(currentUserId)
        } else {
          roleOp.push(-1)
        }
      } else {
        if (this._view.departmentTeamUser && this._view.departmentTeamUser.length > 0) {
          if (searchOpEqualOperation) {
            if (this._view.departmentTeamUser.includes(searchOp1.value)) {
              roleOp.push(searchOp1.value)
            } else {
              if (Number(searchOp1.value) === currentUserId) {
                roleOp.push(currentUserId)
              } else {
                roleOp.push(-1)
              }
            }
          } else {
            roleOp.push(...([...this._view.departmentTeamUser, currentUserId]).filter(item => {
              return item !== searchOp1.value
            }))
          }
        }
      }
      roleSales.push(-1)
    } else if (!AdvancedSearchOption.hasField('job.op_id', $conditions) && AdvancedSearchOption.hasField('job.sales_id', $conditions)) {
      const searchSales1 = AdvancedSearchOption.getOption('job.sales_id', $conditions)
      const searchSalesEqualOperation = searchSales1.operator === '=' // 【等于】条件
      if (!isDepartment) {
        if (searchSalesEqualOperation ? Number(searchSales1.value) === currentUserId : Number(searchSales1.value) !== currentUserId) {
          roleSales.push(currentUserId)
        } else {
          roleSales.push(-1)
        }
      } else {
        if (this._view.departmentTeamUser && this._view.departmentTeamUser.length > 0) {
          if (searchSalesEqualOperation) {
            if (this._view.departmentTeamUser.includes(searchSales1.value)) {
              roleSales.push(searchSales1.value)
            } else {
              if (Number(searchSales1.value) === currentUserId) {
                roleSales.push(currentUserId)
              } else {
                roleSales.push(-1)
              }
            }
          } else {
            roleSales.push(...([...this._view.departmentTeamUser, currentUserId]).filter(item => {
              return item !== searchSales1.value
            }))
          }
        }
      }
      roleOp.push(-1)
    } else {
      if (!isDepartment || this._view.departmentTeamUser === null || this._view.departmentTeamUser.length === 0) {
        roleOp.push(currentUserId)
        roleSales.push(currentUserId)
      } else {
        roleOp.push(...this._view.departmentTeamUser)
        roleSales.push(...this._view.departmentTeamUser)
      }
    }
    role.roleOp = roleOp
    role.roleSales = roleSales
    return role
  }

  /**
   * 同组、个人，根据权限组装用户
   */
  getRoleByOpUsers(isDepartment) {
    const role = {}
    const currentUserId = this._view.$store.getters.userId
    let roleOp = []
    let roleSales = []
    let roleCsr = []
    let roleDc = []
    // 包含某个查询条件
    const hasOp = this.hasField('job.op_id')
    const hasSales = this.hasField('job.sales_id')
    const hasCsr = this.hasField('job.csr_id')
    const hasDc = this.hasField('job.dc_id')
    //
    if (!hasOp && !hasSales && !hasCsr && !hasDc) {
      if (!isDepartment || !this._view.departmentTeamUser || this._view.departmentTeamUser.length === 0) {
        roleOp.push(currentUserId)
        roleSales.push(currentUserId)
        roleCsr.push(currentUserId)
        roleDc.push(currentUserId)
      } else {
        roleOp.push(...this._view.departmentTeamUser)
        roleSales.push(...this._view.departmentTeamUser)
        roleCsr.push(...this._view.departmentTeamUser)
        roleDc.push(...this._view.departmentTeamUser)
      }
    } else {
      roleOp = this.getRoleByUser(isDepartment, 'job.op_id')
      roleSales = this.getRoleByUser(isDepartment, 'job.sales_id')
      roleCsr = this.getRoleByUser(isDepartment, 'job.csr_id')
      roleDc = this.getRoleByUser(isDepartment, 'job.dc_id')
    }
    role.roleOp = roleOp
    role.roleSales = roleSales
    role.roleCsr = roleCsr
    role.roleDc = roleDc
    return role
  }

  // 组装岗位权限
  getRoleByUser(isDepartment, fieldName) {
    const roleList = []
    const hasOp = this.hasField(fieldName)
    if (!hasOp) {
      roleList.push(-1)
      return roleList
    }
    const currentUserId = this._view.$store.getters.userId
    const searchOption = this.getOption(fieldName)
    const isEqual = searchOption.operator === '=' // 【等于】条件
    const isCurrentUser = Number(searchOption.value) === currentUserId
    if (!isDepartment) {
      if (isEqual ? isCurrentUser : !isCurrentUser) {
        roleList.push(currentUserId)
      } else {
        roleList.push(-1)
      }
    } else {
      if (this._view.departmentTeamUser && this._view.departmentTeamUser.length > 0) {
        if (isEqual) {
          if (this._view.departmentTeamUser.includes(searchOption.value)) {
            roleList.push(searchOption.value)
          } else {
            roleList.push(isCurrentUser ? currentUserId : -1)
          }
        } else {
          roleList.push(...([...this._view.departmentTeamUser, currentUserId]).filter(item => {
            return item !== searchOption.value
          }))
        }
      }
    }
    return roleList
  }

  // 包含查询条件
  hasField(fieldName) {
    const $conditions = this._view.searchConditions.snapshotConditions
    return AdvancedSearchOption.hasField(fieldName, $conditions)
  }

  // 获取查询条件
  getOption(fieldName) {
    const $conditions = this._view.searchConditions.snapshotConditions
    return AdvancedSearchOption.getOption(fieldName, $conditions)
  }

  /**
   * 修改状态-按钮可操作性的状态
   */
  updateDefaultMenuState() {

  }

  /**
   * 获取合计全部利润后的处理方法
   * @param wapper
   */
  resultHandlerForTotalProfit(wapper) {
    this.totalProfits = wapper.otherResult == null ? null : wapper.otherResult['totalProfit']
    if (this.needCalcAfterLoadTotalProfit) {
      this.refreshSelectedCount(false)
      this.needCalcAfterLoadTotalProfit = false
    }
  }

  clearBottomTotalData() {
    this.totalProfits = []
    this.totalGroupIncome.dataProvider = this.totalProfits
    this.totalGroupCost.dataProvider = this.totalProfits
    this.totalGroup.dataProvider = this.totalProfits
  }

  resultHandler(wapper) {
    this.selectionUuids = null
    if (!this.totalProfits || !this.totalProfits.length) {
      this.needCalcAfterLoadTotalProfit = true
    }
    // console.log('wapper', wapper)
    if (!this._view.searchExportExcel) {
      ClearingUtils.mergeVoucherResult(wapper)
      ChargeUtils.ChargeUtils.calcIsVerification(wapper)
      if (!this._view.showTotalProfit) {
        this.totalGroupIncome.dataProvider = wapper.results.list
        this.totalGroupCost.dataProvider = wapper.results.list
        this.totalGroup.dataProvider = wapper.results.list
      } else {
        // this.totalProfits = wapper.otherResult == null ? null : wapper.otherResult['totalProfit']
        // this.totalGroupIncome.dataProvider = this.totalProfits
        // this.totalGroupCost.dataProvider = this.totalProfits
        // this.totalGroup.dataProvider = this.totalProfits
        this.allChargeSummary = wapper.chargeSummary || []
      }
    } else {
      // // todo-shengsheng  Desc: excel 处理
      // const dyEvt:DynamicEvent = new DynamicEvent("searchExportExcel");
      // dyEvt.data = event.result as IList;
      // dispatchEvent(dyEvt);
    }
    // 是否生成凭证
    if (this._view.hasVoucher !== undefined && this._view.hasVoucher !== -1) {
      const dataShowList = this.filterConflictSlaves(wapper.results.list)
      this.totalGroupIncome.dataProvider = dataShowList
      this.totalGroupCost.dataProvider = dataShowList
      this.totalGroup.dataProvider = dataShowList
    } else {
      this.refreshSelectedCount()
    }
  }
  /**
   * 选择主票时去除其小票
   */
  filterConflictSlaves(jobs = []) {
    const jobUuids = jobs.map(job => job.uuid)
    return jobs.filter(job => {
      return !(job.lclMasterUuid && jobUuids.includes(job.lclMasterUuid))
    })
  }
  // 右下角统计
  refreshSelectedCount(needLoading = true) {
    this._view.selectionCountLabel = ''
    if (needLoading) {
      this.loading()
    }
    const allSelections = getGridSelected(this._view.gridOptions)
    const length = allSelections.length
    const selections = this.filterConflictSlaves(allSelections)
    const currentSelectionsUuids = selections.map(item => item.uuid)
    if (this._view.showSelectionCount && length > 0) {
      this._view.selectionCountLabel = this._view.$t('CargoMsg.Cargo_Select') + ' ' + length + ':'
    }
    this.selectionUuids = currentSelectionsUuids
    if (length > 0) {
      // 选中数据
      this.totalGroup.dataProvider = selections
      this.totalGroupIncome.dataProvider = selections
      this.totalGroupCost.dataProvider = selections
    } else if (this._view.showTotalProfit) {
      const rowData = this._view.rowData || []
      const selections = this.filterConflictSlaves(rowData)
      this.totalGroup.dataProvider = selections
      this.totalGroupIncome.dataProvider = selections
      this.totalGroupCost.dataProvider = selections
    } else {
      // 当前页显示数据
      let dataShowList = []
      this._view.gridOptions.api.forEachNode((node, index) => {
        if (!node.data) {
          return
        }
        if (node.displayed) {
          dataShowList.push(node.data)
        }
      })
      // 需要把主票下的小票过滤掉
      dataShowList = this.filterConflictSlaves(dataShowList)
      this.totalGroup.dataProvider = dataShowList
      this.totalGroupIncome.dataProvider = dataShowList
      this.totalGroupCost.dataProvider = dataShowList
    }
    // 刷新右下角统计
    if (this.chargeCountGroup && this.showChargeCount) {
      // 合计详情数据处理
      this.chargeCountGroup.dataProvider = []
      let list = []
      if (length > 0) {
        // 选中数据
        list = allSelections.map(item => item.uuid)
        this.chargeCountGroup.selectedCount = allSelections.length
      } else if (this._view.showTotalProfit) {
        // 当前页数据
        list = this._view.rowData.map(item => item.uuid)
        this.chargeCountGroup.selectedCount = 0
      } else {
        // 当前页显示数据
        const dataShowList = []
        this._view.gridOptions.api.forEachNode((node, index) => {
          if (!node.data) {
            return
          }
          if (node.displayed) {
            dataShowList.push(node.data.uuid)
          }
        })
        list = dataShowList
        this.chargeCountGroup.selectedCount = 0
      }
      this.chargeCountGroup.showCurrency = true
      if (list.length > 0) {
        const summaryList = this.allChargeSummary.filter(item => {
          return (list.includes(item.jobUUid))
        })
        const dataProvider = []
        for (const item of summaryList) {
          if (item.shareRefNo) {
            let filter = false
            for (const item2 of summaryList) {
              if (item2.apportioned && item2.chargeId + '' === item.shareRefNo) {
                filter = true
                break
              }
            }
            if (filter) {
              continue
            }
          }
          dataProvider.push(item)
        }
        this.chargeCountGroup.dataProvider = dataProvider
      }
    }
    if (needLoading) {
      this.closeLoading()
    }
  }
  //
  queryFieldSuccess(list) {
    if (list.length > 0) {
      this.chargeCountGroup.dataProvider = list
      console.log('this.chargeCountGroup.dataProvider', this.chargeCountGroup.dataProvider)
    } else {
      // this.chargeCountGroup.clearChargeCountWindow();
      // // todo-shengsheng  Desc: 清空数据
    }
  }
}
